<template>
  <div class="flex h-screen overflow-hidden">
    <div class="bg-blue relative hidden flex-1 overflow-hidden lg:block">
      <img
        src="/images/background-fireworks.svg"
        alt=""
        aria-hidden="true"
        class="absolute top-1/2 left-1/2 w-[135%] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-60"
      />
      <NuxtLink to="/" class="absolute top-10 left-1/2 -translate-x-1/2">
        <SvgLogo class="text-grey h-[72px]" />
      </NuxtLink>
      <h1
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-[clamp(3.5rem,7vw,100px)] leading-[0.9em] font-medium tracking-[-3px] text-black"
      >
        Manage<br />commitment
      </h1>
    </div>
    <div class="flex-1 overflow-y-auto">
      <div
        class="relative flex h-[176px] items-center justify-center overflow-hidden bg-[#94e4e1] md:h-[152px] lg:hidden"
      >
        <img
          src="/images/background-fireworks.svg"
          alt=""
          aria-hidden="true"
          class="pointer-events-none absolute top-1/2 left-1/2 w-[135%] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-60"
        />
        <NuxtLink to="/" class="relative z-10">
          <SvgLogo class="text-grey h-16 md:h-[72px]" />
        </NuxtLink>
      </div>
      <slot />
    </div>
  </div>
</template>
